import { useGlobalState } from "../../hooks/useGlobalState"

export const Confirmation = () => {
   const { orderResponse } = useGlobalState()
  
   return (
      <div className="confirmation">
         {orderResponse.success &&
            <div>
               <section>
                  <h1>Confirmation!</h1>
                  <p>You’re all set to attend the Venture Summit! Confirmation has been sent to your email.</p>
                  <p>If you have bought multiple tickets or acquired a ticket on behalf of someone else, they will receive their ticket via email as well.</p>
               </section>
               <section>
                  <div>
                     <h1>Your Order Details</h1>
                     <h3>Order ID #<span>{orderResponse.order?.order_id}</span></h3>
                  </div>
                  {orderResponse.order?.tickets?.map((t, idx) =>
                     <div key={idx}>
                        <h3>{t.name}</h3>
                        <h3>#<span>{t.ticket_id}</span></h3>
                     </div>
                  )}
               </section>
            </div>
            }
      </div>
   )
}
